const deleteActionsStore = {
  toastrSuccess: 'Action deleted',
  toastrSuccess1: 'successfully deleted'
};

export default deleteActionsStore;
